import React, { useEffect, useRef, useState } from 'react';
import { useMouseOverZoom } from '@/functions/useMouseOverZoom';
import AppImage from '@/components/common/AppImage';
import { useLayoutContext } from '@/context/LayoutContext';
import useWindowDimensions from '@/functions/useWindowDimensions';
import ProductBadges from '../../../ProductsContent/ProductCard/ProductBadges';
// import ProductBadges from '@/components/pages/home/HomeContent/HomeFeatured/ProductCard/ProductBadges';

export default function ZoomImage({ activeImage, data }) {
  const imageRef = useRef(null);
  const canvasRef = useRef(null);
  const cursorRef = useRef(null);

  const [showZoom, setShowZoom] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const { dir } = useLayoutContext();
  const { width } = useWindowDimensions();

  const mouse = useMouseOverZoom(imageRef, canvasRef, cursorRef, 50);

  useEffect(() => {
    setImageLoaded(true);
    setShowZoom(false);
  }, [activeImage]);

  console.log('zoomimage==', imageLoaded, showZoom);
  let src = activeImage?.name?.startsWith('/imgs/')
    ? activeImage?.name
    : activeImage?.name?.startsWith('http')
      ? activeImage?.name
      : `${process.env.IMAGE_URL}${activeImage?.name}`;
  // background:
  //   'repeating-linear-gradient(135deg, oklch(0.26 0.02 258 / 0.5) 0 2px, transparent 2px 11px), radial-gradient(120% 90% at 50% 18%, oklch(0.3 0.03 258), oklch(0.18 0.018 258))',
  // 'repeating-linear-gradient(135deg, oklch(0.95 0.03 258.36 / 0.5) 0 2px, transparent 2px 11px), radial-gradient(120% 90% at 50% 18%, oklch(1 0 0), oklch(0.9 0.01 258.62))',
  background: return (
    <div
      style={{
        justifySelf: 'center',
        margin: 'auto 0px',
        minHeight: 'unset',
        width: '100%',
        background:
          'repeating-linear-gradient(135deg, oklch(0.26 0.02 258 / 0.5) 0 2px, transparent 2px 11px), radial-gradient(120% 90% at 50% 18%, oklch(0.3 0.03 258), oklch(0.18 0.018 258))',
        borderRadius: 'var(--r-xl)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: width > 940 ? '0px 10px' : '60px 10px',
        aspectRatio: width > 940 ? '1' : 'unset',
        position: 'relative',
        height: '400px',
        borderRadius: '20px',
      }}
    >
      <ProductBadges data={data} />
      <div
        style={{
          position: 'relative',
          display: 'inline-block',
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      >
        <img
          ref={imageRef}
          src={activeImage?.name}
          alt="Zoomable"
          style={{
            display: 'block',
            borderRadius: '8px',
            maxWidth: '100%',
            maxHeight: '300px',
            width: 'auto',
            height: 'auto',
          }}
          onMouseEnter={() => imageLoaded && setShowZoom(true)}
          onMouseLeave={() => setShowZoom(false)}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(false)}
        />

        {/* Zoom cursor */}
        <div
          ref={cursorRef}
          style={{
            position: 'absolute',
            border: '2px solid #007bff',
            pointerEvents: 'none',
            display: 'none',
          }}
        />
      </div>

      {/* Zoomed canvas following cursor */}
      {imageLoaded && showZoom && (
        <canvas
          ref={canvasRef}
          width={200}
          height={200}
          style={{
            position: 'fixed',
            // left: mouse.clientX + 20,
            left:
              width > 940
                ? dir == 'rtl'
                  ? mouse.clientX - 200 - 20
                  : mouse.clientX - 20
                : mouse.clientX - 100,
            top: mouse.clientY + 20,
            border: '2px solid #eee',
            borderRadius: '4px',
            backgroundColor: '#fff',
            pointerEvents: 'none',
            zIndex: 1000,
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          }}
        />
      )}
    </div>
  );
}
// ==========================================

// // ZoomImage.js
// import React, { useRef, useState } from "react";
// import { useMouseOverZoom } from "@/functions/useMouseOverZoom";
// import AppImage from "@/components/base/AppImage";

// export default function ZoomImage({ activeImage }) {
//   const imageRef = useRef(null);
//   const canvasRef = useRef(null);
//   const cursorRef = useRef(null);

//   const [isZoomActive, setIsZoomActive] = useState(false);

//   useMouseOverZoom(
//     imageRef,
//     canvasRef,
//     cursorRef,
//     isZoomActive
//   );

//   return (
//     <div style={{ padding: 50 }}>
//       <div style={{ position: "relative", width: 400 }}>

//         {/* ORIGINAL IMAGE */}
//         {!isZoomActive && (
//           <AppImage
//             ref={imageRef}
//             src={activeImage?.image?.name}
//             style={{ width: "100%", cursor: "zoom-in" }}
//             alt="Zoomable"
//             onClick={() => setIsZoomActive(true)}
//           />
//         )}

//         {/* ZOOM MODE */}
//         {isZoomActive && (
//           <>
//             <AppImage
//               ref={imageRef}
//               src={activeImage?.image?.name}
//               style={{ width: "100%" }}
//               alt="Zoom Source"
//             />

//             <div
//               ref={cursorRef}
//               style={{
//                 position: "absolute",
//                 border: "2px solid #00f",
//                 pointerEvents: "none",
//                 display: "none",
//               }}
//             />

//             <canvas
//               ref={canvasRef}
//               width={200}
//               height={200}
//               onClick={() => setIsZoomActive(false)}
//               style={{
//                 position: "absolute",
//                 right: "-230px",
//                 top: "0",
//                 border: "3px solid #000",
//                 backgroundColor: "#fff",
//                 cursor: "zoom-out",
//               }}
//             />
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// ========================

// // ====================================
// // ZoomImage.jsx
// import { useEffect, useRef, useState } from 'react';
// import AppImage from "@/components/base/AppImage";
// import styles from './styles.module.css';

// const ZoomImage = ({ activeImage }) => {
//   const [active, setActive] = useState(false);
//   const [imageLoaded, setImageLoaded] = useState(false);
//   const containerRef = useRef(null);
//   const imgRef = useRef(null);
//   const lensRef = useRef(null);

//   const ZOOM_FACTOR = 2.8;   // ← increase if you want stronger zoom (try 3.0–4.0)
//   const LENS_SIZE   = 200;   // px – larger lens = easier to see detail

//   // Re-apply background size & position when needed
//   const updateLensBackground = () => {
//     const lens = lensRef.current;
//     const img = imgRef.current;
//     if (!lens || !img || !img.naturalWidth) return;

//     const scaledW = img.naturalWidth * ZOOM_FACTOR;
//     const scaledH = img.naturalHeight * ZOOM_FACTOR;

//     lens.style.backgroundSize = `${scaledW}px ${scaledH}px`;
//     lens.style.backgroundImage = `url(${img.currentSrc || img.src})`;
//   };

//   useEffect(() => {
//     const img = imgRef.current;
//     if (!img) return;

//     if (img.complete) {
//       setImageLoaded(true);
//       updateLensBackground();
//     } else {
//       img.addEventListener('load', () => {
//         setImageLoaded(true);
//         updateLensBackground();
//       });
//     }

//     // Cleanup
//     return () => {
//       img.removeEventListener('load', () => {});
//     };
//   }, [activeImage?.image?.name]);

//   useEffect(() => {
//     if (!imageLoaded) return;

//     const container = containerRef.current;
//     const lens = lensRef.current;

//     if (!container || !lens) return;

//     const updateLensPosition = (e) => {
//       if (!active) return;

//       const rect = container.getBoundingClientRect();
//       const x = e.clientX - rect.left;
//       const y = e.clientY - rect.top;

//       const half = LENS_SIZE / 2;
//       let left = x - half;
//       let top  = y - half;

//       left = Math.max(0, Math.min(rect.width - LENS_SIZE, left));
//       top  = Math.max(0, Math.min(rect.height - LENS_SIZE, top));

//       lens.style.left = `${left}px`;
//       lens.style.top  = `${top}px`;

//       // The key line: move background in opposite direction
//       lens.style.backgroundPosition = `-${left * ZOOM_FACTOR}px -${top * ZOOM_FACTOR}px`;
//     };

//     const show = () => setActive(true);
//     const hide = () => setActive(false);

//     container.addEventListener('mouseenter', show);
//     container.addEventListener('mouseleave', hide);
//     container.addEventListener('mousemove', updateLensPosition);

//     // Touch
//     const touchMove = (e) => {
//       if (e.touches.length !== 1) return;
//       e.preventDefault();
//       show();
//       updateLensPosition(e.touches[0]);
//     };

//     container.addEventListener('touchstart', show, { passive: false });
//     container.addEventListener('touchmove', touchMove, { passive: false });
//     container.addEventListener('touchend', hide);

//     // Initial update in case already hovered
//     if (active) updateLensBackground();

//     return () => {
//       container.removeEventListener('mouseenter', show);
//       container.removeEventListener('mouseleave', hide);
//       container.removeEventListener('mousemove', updateLensPosition);
//       container.removeEventListener('touchstart', show);
//       container.removeEventListener('touchmove', touchMove);
//       container.removeEventListener('touchend', hide);
//     };
//   }, [active, imageLoaded, activeImage?.image?.name]);

//   return (
//     <div ref={containerRef} className={styles.zoomContainer}>
//       <AppImage
//         ref={imgRef}
//         src={activeImage?.image?.name}
//         alt="Zoomable product"
//         containerclassName={styles.imageWrapper}
//         className={styles.mainImage}
//       />

//       <div
//         ref={lensRef}
//         className={`${styles.magnifier} ${active && imageLoaded ? styles.active : ''}`}
//         style={{
//           width: `${LENS_SIZE}px`,
//           height: `${LENS_SIZE}px`,
//         }}
//       />
//     </div>
//   );
// };

// export default ZoomImage;

// ==============

// import React, { useState, useRef } from "react";
// import ReactDOM from "react-dom";

// /*
//  * Functional React component
//  */
// export default function ZoomImage({ activeImage }) {
//   const imageSrc = `${process.env.IMAGE_URL}${activeImage?.image?.name}`;

//   const [isZoomOnSide, setIsZoomOnSide] = useState(true);
//   const [showOverlay, setShowOverlay] = useState(false);
//   const [overlayLeft, setOverlayLeft] = useState(0);
//   const [overlayTop, setOverlayTop] = useState(0);
//   const [zoomInLeft, setZoomInLeft] = useState(0);
//   const [zoomInTop, setZoomInTop] = useState(0);
//   const [zoomInMaxWidth, setZoomInMaxWidth] = useState(0);

//   const imageRef = useRef(null);
//   const overlayRef = useRef(null);
//   const zoomInImageRef = useRef(null);
//   const zoomInWindowRef = useRef(null);

//   if (!imageSrc) return null;

//   const onMouseMove = e => {
//     if (
//       !imageRef.current ||
//       !zoomInImageRef.current ||
//       !zoomInWindowRef.current
//     ) {
//       return;
//     }

//     const imageNode = imageRef.current;
//     const overlayNode = overlayRef.current;
//     const zoomInImageNode = zoomInImageRef.current;
//     const zoomInWindowNode = zoomInWindowRef.current;

//     const overlayWidth = overlayNode?.clientWidth || 100;
//     const imageWidth = imageNode.clientWidth;
//     const imageHeight = imageNode.clientHeight;

//     const zoomInImageWidth = zoomInImageNode.clientWidth;
//     const zoomInImageHeight = zoomInImageNode.clientHeight;

//     const offsetLeft = imageNode.offsetLeft;
//     const offsetTop = imageNode.offsetTop;

//     const overlayX = Math.min(
//       Math.max(e.clientX - overlayWidth / 2, offsetLeft),
//       offsetLeft + imageWidth - overlayWidth
//     );

//     const overlayY = Math.min(
//       Math.max(e.clientY - overlayWidth / 2, offsetTop),
//       offsetTop + imageHeight - overlayWidth
//     );

//     const zoomLeft =
//       -((overlayX - offsetLeft) / imageWidth) * zoomInImageWidth;
//     const zoomTop =
//       -((overlayY - offsetTop) / imageHeight) * zoomInImageHeight;

//     const zoomWindowWidth = zoomInWindowNode.clientWidth;
//     const maxWidth = zoomWindowWidth / (overlayWidth / imageWidth);

//     setOverlayLeft(overlayX);
//     setOverlayTop(overlayY);
//     setZoomInLeft(zoomLeft);
//     setZoomInTop(zoomTop);
//     setZoomInMaxWidth(maxWidth);
//   };

//   const overlayStyle = {
//     left: overlayLeft,
//     top: overlayTop
//   };

//   const zoomInImageStyle = {
//     position: "relative",
//     left: zoomInLeft,
//     top: zoomInTop,
//     ...(isZoomOnSide && zoomInMaxWidth
//       ? { maxWidth: zoomInMaxWidth }
//       : {})
//   };

//   return (
//     <div>
//       <button
//         className="SwitchButton"
//         onClick={() => setIsZoomOnSide(prev => !prev)}
//       >
//         {isZoomOnSide ? "Zoom Outside" : "Zoom Inside"}
//       </button>

//       <div
//         className="OriginalImageContainer"
//         onMouseMove={onMouseMove}
//         onMouseEnter={() => setShowOverlay(true)}
//         onMouseLeave={() => setShowOverlay(false)}
//       >
//         <img
//           ref={imageRef}
//           className="OriginalImage"
//           src={imageSrc}
//           alt=""
//         />

//         {showOverlay && isZoomOnSide && (
//           <span ref={overlayRef} style={overlayStyle} />
//         )}

//         {showOverlay && !isZoomOnSide && (
//           <div ref={zoomInWindowRef} className="ZoomInWindowInside">
//             <img
//               ref={zoomInImageRef}
//               className="ZoomInWindow-Image"
//               src={imageSrc}
//               style={zoomInImageStyle}
//               alt=""
//             />
//           </div>
//         )}
//       </div>

//       {showOverlay && isZoomOnSide && (
//         <div ref={zoomInWindowRef} className="ZoomInWindow">
//           <img
//             ref={zoomInImageRef}
//             className="ZoomInWindow-Image"
//             src={imageSrc}
//             style={zoomInImageStyle}
//             alt=""
//           />
//         </div>
//       )}
//     </div>
//   );
// }
